// RoofMaster — standalone page for Robert's Roof Master grid (Jul 30, 2026).
//
// Requested by Robert Ayers: the Roof Master spreadsheet view was buried as a
// collapsible, desktop-only section at the bottom of Dispatch Board → Schedule.
// This page gives the grid the full viewport on its own route.
//
// RoofMasterTable is fully self-sufficient (own realtime subs on deals +
// roof_master_layout + custom_field_definitions + roof_master_views), so no
// reloadKey plumbing is needed here — the default of 0 is fine.
//
// Route: /roof-master (same role set as /dispatch; super-users bypass).

import { Link } from "react-router-dom";
import RoofMasterTable from "../components/dispatch/RoofMasterTable";

export default function RoofMaster() {
  return (
    <div className="px-4 py-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-bold text-bardin-ink">📋 Roof Master</h1>
          <p className="text-xs text-slate-500">
            Every deal in the claims + build lifecycle — click a cell to edit, ⚙ Columns to customize, tabs below for saved views.
          </p>
        </div>
        <Link
          to="/dispatch"
          className="text-sm text-slate-500 hover:text-bardin-ink px-3 py-1.5 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition"
        >
          🚚 Dispatch Board →
        </Link>
      </div>

      {/* Phones: the grid works but is cramped — gentle hint, not a block. */}
      <p className="mb-3 text-[11px] text-slate-400 lg:hidden">
        Tip: the Roof Master grid is easiest on a desktop or tablet in landscape.
      </p>

      <div className="p-3 bg-white rounded-lg border border-slate-200 overflow-x-auto">
        <RoofMasterTable />
      </div>
    </div>
  );
}
